import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { TypeAnn } from '../../../common/models/type.ann';

@Component({
  selector: 'app-formmapa',
  templateUrl: './formmapa.component.html'
})
export class FormmapaComponent implements OnInit {

  public form: FormGroup;
  @Input() referenceAvis: string;
  @Input() currentJson: any = new BehaviorSubject(null);
  public ann : TypeAnn;

  constructor() { }

  public ngOnInit() {
    this.initForm();
    this.form = new FormGroup({});
  }

  public getForm() {
    return this.form;
  }

  private initForm() {
    if (this.currentJson) { this.ann = this.currentJson.jsonSaisieFormulaire.ann; return; }
  }
}
